// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2s2tr","content":"LayoutSettings_content__3TZCU"};